import type { CmsEntry, CmsEntryValues, CmsModel } from "~/types/index.js";

export function getEntryTitle<T extends CmsEntryValues = CmsEntryValues>(
    model: Pick<CmsModel, "titleFieldId" | "fields">,
    entry: Pick<CmsEntry<T>, "id" | "values">
): string {
    if (!model.titleFieldId) {
        return entry.id;
    }
    const field = model.fields.find(f => f.fieldId === model.titleFieldId);
    if (!field) {
        return entry.id;
    }
    const titleFieldId = field.fieldId as keyof T;
    const titleValue = entry.values[titleFieldId];
    if (!titleValue || typeof titleValue !== "string") {
        return entry.id;
    }

    const { enabled = false, values } = field.predefinedValues || {};
    if (!enabled || !values || Array.isArray(values) === false) {
        return titleValue;
    }
    for (const value of values) {
        // needs to be loose because titleValue can be a number and value can be a string - but it must match
        if (value.value == titleValue) {
            return value.label;
        }
    }
    return titleValue;
}
